import { styled } from 'styled-components';

export const RangeSliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;

  h3 {
    ${({ theme }) => theme.typography.headingSmall}
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }

  .track {
    height: 4px !important;
    width: calc(100% - 0.5rem) !important;
  }
  .thumb {
    border: 2px solid ${({ theme }) => theme.colours.canvas.tertiary.main};
    border-radius: ${({ theme }) => theme.borderRadius.ellipse};
    height: 16px;
    width: 16px;
    margin-top: -6px;
  }
`;
RangeSliderWrapper.displayName = 'RangeSliderWrapper';

export const SearchWithList = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.sizing.small};

  h3 {
    ${({ theme }) => theme.typography.headingSmall}
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }
`;
SearchWithList.displayName = 'SearchWithList';

export const SearchResultHolder = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.sizing.tiny}
    ${({ theme }) => theme.sizing.medium};
`;
SearchResultHolder.displayName = 'SearchResultHolder';

export const SearchResultsLoading = styled.div`
  width: 100%;
  height: 2px;
  text-align: center;
`;
SearchResultsLoading.displayName = 'SearchResultsLoading';

export const SearchResults = styled.ul`
  width: 100%;
  max-height: 200px;
  overflow: auto;
  list-style-type: none;
  padding: 0;
  border-radius: ${({ theme }) => theme.borderRadius.tertiary};
  margin: 0;
  border: ${({ theme }) =>
    `${theme.sizing.xxtiny} solid ${theme.colours.canvas.primary.main}`};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
`;
SearchResults.displayName = 'SearchResults';

export const ChipHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.sizing.xtiny};
  padding: ${({ theme }) => theme.sizing.tiny} 0;
`;
ChipHolder.displayName = 'ChipHolder';

export const BiometricDropdownWrapper = styled.div`
  label {
    ${({ theme }) => theme.typography.headingSmall}
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }
`;
BiometricDropdownWrapper.displayName = 'BiometricDropdownWrapper';

export const SearchResultLi = styled.li`
  height: 24px;
  padding: ${({ theme }) => theme.sizing.tiny};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.sizing.xtiny};
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  color: ${({ theme }) => theme.colours.ink.primary.main};

  &:hover {
    background: ${({ theme }) => theme.colours.canvas.secondary.main};
  }
`;
SearchResultLi.displayName = 'SearchResultLi';

export const ScoutToggleWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};
`;
ScoutToggleWrapper.displayName = 'ScoutToggleWrapper';

export const ScoutBioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.medium};
  width: 100%;
`;
ScoutBioWrapper.displayName = 'ScoutBioWrapper';
